import { render, staticRenderFns } from "./epb-facets-modal.component.vue?vue&type=template&id=7c27e42c&scoped=true"
import script from "./epb-facets-modal.component.vue?vue&type=script&lang=ts"
export * from "./epb-facets-modal.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c27e42c",
  null
  
)

export default component.exports